import React from 'react';
// images
import womanDrinkingCoffee from  '../../../../../images/components/experienceCalloutImages/woman-drinking-coffee-and-looking-out-the-window-reversed.webp';
// styles
import { ExperienceCalloutStyled } from './styles';

export default () => (
  <ExperienceCalloutStyled
    // configs
    sectionId='quiz-callout-non-qualified-retirement-plan'
    moduleName='quiz-callout-module'
    moduleVariation='A'
    backgroundVariant='darkDefault'
    calloutBackgroundVariant='darkDefault'
    calloutThemeType='darkTheme'
    themeType='darkTheme'
    disableLazyLoad
    isFullWidth
    withBGImage
    // content
    imageUrl={womanDrinkingCoffee.toString()}
    headingText='Am I on track for retirement&#63;'
    buttonText='Take our quiz'
    linkUrl='/life-and-money/quiz/am-i-on-track-for-retirement/'
    ariaLabel='Take our retirement quiz.'
  />
);
